import findIndex from 'lodash/findIndex';
import { Component, Input, Output, EventEmitter, ViewChild, ElementRef, OnInit, AfterViewInit } from '@angular/core';
import { IMultiUrlImage } from '@cakeiteasy/web-utils';

@Component({
  standalone: false,
  selector: 'ui-extra-products-radio',
  templateUrl: './ui-extra-products-radio.component.html',
  styleUrls: ['./ui-extra-products-radio.component.scss']
})
export class UiExtraProductsRadioComponent implements OnInit, AfterViewInit {
  @ViewChild('wrap', { static: false }) public wrap: ElementRef;
  @ViewChild('content', { static: false }) public content: ElementRef;

  @Input() public selectedItem: any;
  @Input() public showPictures: boolean = false;
  public isExpand: boolean = false;
  public contentHeight: number | string = 'auto';

  // number of items that can be selected in collapse mode
  @Input() public collapseItemsQuantity = 4;
  public showingQuantity: number;

  @Input() public items: any[];

  @Output() public onImageSelect = new EventEmitter<{ image: IMultiUrlImage, offsetTop?: number, show?: boolean }>();
  @Output() public modelChange = new EventEmitter<string>();

  @Input()
  public get model() {
    return this.selectedItem;
  }

  public set model(selectedItem: any) {
    this.selectedItem = selectedItem;
    this.modelChange.emit(selectedItem);
  }

  ngOnInit() {
    this.showingQuantity = this.collapseItemsQuantity + 1;
    this._checkExpand();
  }

  ngAfterViewInit() {
    this.setContentHeight(1000);
  }

  public toggle() {
    this.isExpand = !this.isExpand;
    this.setContentHeight();
  }

  public setContentHeight(delay?: number) {
    delay = delay || 0;
    setTimeout(() => {
      this.contentHeight = this.content.nativeElement.clientHeight;
    }, delay);
  }

  public selectImage(image, event) {
    const offsetTop = event.target.offsetTop;
    this.onImageSelect.emit({ image, offsetTop });
  }

  public clearChoice() {
    this.model = [];
  }

  public isShowExtraProduct(ind) {
    return this.isExpand || (ind + 1) <= this.showingQuantity;
  }

  public isShowOverlay(ind) {
    return !this.isExpand && (ind + 1) === this.showingQuantity;
  }

  private _checkExpand() {
    this.isExpand = !this.isExpand && this._isNotShowingItemSelected() || this.items.length <= this.showingQuantity;
  }

  private _isNotShowingItemSelected() {
    if (!this.model.id) {
      return false;
    }

    const selectedItemIndex = findIndex(this.items, (item) => item.value.id === this.model.id);
    return (selectedItemIndex + 1) >= this.showingQuantity;
  }
}
